import { AppLayout } from './AppLayout';

/**
 * Centres a page's content, picking its own chrome from the auth state.
 *
 * For the routes `routes.tsx` mounts BARE — no guard, no `AppLayout`, no
 * `PageBoundary` — of which the `*` catch-all is the one today. Such a page
 * cannot assume the app shell is above it, because for a signed-out visitor it
 * is not, so it has to draw the shell itself in one branch and a plain
 * full-height column in the other.
 *
 * This was an unnamed `if (user) {…} else {…}` inside `NotFoundPage`. Naming it
 * is most of the value: the two branches look like duplication until you see
 * that one is `h-full` inside a `<main>` that is already `h-screen
 * overflow-hidden`, and the other is `min-h-screen` because nothing above it
 * has a height at all.
 *
 * Neither branch paints a `GridBackground` — the app shell in `app/provider.tsx`
 * already lays the ground and lattice above every route.
 */
export function CenteredPageShell({
  signedIn,
  children,
}: {
  signedIn: boolean;
  children: React.ReactNode;
}) {
  if (signedIn) {
    return (
      <AppLayout>
        <div className='flex h-full items-center justify-center'>
          <div className='flex flex-col items-center justify-center px-4'>
            {children}
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <div className='min-h-screen'>
      <div className='flex min-h-screen flex-col items-center justify-center px-4'>
        {children}
      </div>
    </div>
  );
}
